import { Authentication } from '@leedpulse-monorepo/classes';
import HttpClient from '../../../core/HttpClient';
import Failure from '../../../core/Failure';

export interface DiscoverApimoResult {
  discovered: number;
  skipped: number;
  errors: string[];
}

/**
 * Manually trigger Apimo agency discovery (staff only).
 * Provisions the company + supervisor for each unknown active Apimo agency.
 */
const discoverApimoAgencies = async (auth: Authentication): Promise<DiscoverApimoResult> => {
  try {
    const response = await HttpClient.post('/integrations/apimo/discover', {}, auth.token);
    // Backend wraps payloads as { success, statusCode, statusReponse, data }
    return (response?.data ?? response) as DiscoverApimoResult;
  } catch (e) {
    if (e instanceof TypeError && e.message === 'Failed to fetch') {
      throw new DiscoverApimoFailure('Le serveur ne répond pas');
    } else if (e instanceof Error) {
      throw new DiscoverApimoFailure(`Erreur lors de l'import des agences Apimo : ${e.message}`, '400');
    }
    throw new DiscoverApimoFailure();
  }
};

export class DiscoverApimoFailure extends Failure {
  constructor(message = 'Unknown error', code = 'discover-apimo-failure') {
    super(message, code);
  }
}

export default discoverApimoAgencies;
